<template>
  <div
    class="w-full md:pr-[24px] md:max-h-[calc(100vh-170px)] overflow-y-auto pt-[12px] pb-[24px]"
  >
    <b-form-group
      label-for="title"
      class="pb-[8px]"
    >
      <template #label>
        <span class="text-[#333] text-[14px] after:content-['*'] after:text-red-500 mb-[8px]">Judul Form</span>
      </template>
      <b-form-input
        id="title"
        name="title"
        placeholder="Masukkan judul form"
      />
    </b-form-group>
    <b-form-group
      label-for="header"
      class="pb-[8px] pt-[20px]"
      style="border-top: 1px dashed #E2E2E2;"
    >
      <template #label>
        <div class="cursor-pointer group">
          <span class="text-[#333] text-[14px] after:content-['*'] after:text-red-500 mb-[16px]">Header Formulir</span>
          <div
            class="relative overflow-hidden bg-[#F4F4F4] rounded-[8px] h-[200px] w-full mb-[24px] grid place-items-center !border border-[#e2e2e2]"
          >
            <img
              src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/gallery-add.svg"
              alt="upload"
              width="32"
              height="32"
            >
            <div class="absolute inset-0 flex items-center pointer-events-none">
              <img
                ref="banner"
                alt="uploaded-banner"
                class="object-cover w-full h-full hidden"
              >
            </div>
          </div>
          <div
            class="h-[40px] w-full rounded-[8px] px-[14px] flex items-center !border border-dashed border-[#e2e2e2] group-hover:border-[#F95031] transition-colors duration-300"
          >
            <div class="flex gap-[8px] items-center">
              <div
                class="flex gap-[8px] items-center h-[24px] rounded-[4px] px-[8px] !border border-[#F95031]"
              >
                <img
                  src="https://storage.googleapis.com/komerce/assets/komerce-icon/Orange/document-upload.svg"
                  alt="upload"
                  width="16"
                  height="16"
                >
                <span class="text-[#F95031] text-[12px] font-semibold">Pilih Foto</span>
              </div>
              <span class="text-[14px] text-[#C2C2C2]">Upload Foto</span>
            </div>
          </div>
          <span class="text-[12px] text-[#828282] mt-[8px]">Upload foto dengan max. 1Mb dan rasio 4:1</span>
        </div>
      </template>
      <b-form-file
        id="header"
        name="header"
        accept="image/*"
        placeholder="Upload Foto"
        class="hidden"
        @change="updateBanner"
      />
    </b-form-group>
    <b-form-group
      label-for="overview"
      class="pb-[8px] pt-[20px]"
    >
      <template #label>
        <span class="text-[#333] text-[14px] after:content-['*'] after:text-red-500 mb-[8px]">Overview</span>
      </template>
      <b-form-textarea
        id="overview"
        name="overview"
        rows="7"
        :maxlength="500"
        placeholder="Masukkan overview"
        @input="value => $refs.overviewCount.textContent = `${value.length}/500`"
      />
      <p
        ref="overviewCount"
        class="text-[12px] text-[#626262] text-right mt-[8px] mb-0"
      >
        0/500
      </p>
    </b-form-group>
    <b-form-group
      label-for="closing_statement"
      class="pb-[8px] pt-[20px]"
    >
      <template #label>
        <span class="text-[#333] text-[14px] after:content-['*'] after:text-red-500 mb-[8px]">Closing Statement</span>
      </template>
      <b-form-textarea
        id="closing_statement"
        name="closing_statement"
        rows="7"
        :maxlength="700"
        placeholder="Masukkan closing statement"
        @input="value => $refs.closingCount.textContent = `${value.length}/700`"
      />
      <p
        ref="closingCount"
        class="text-[12px] text-[#626262] text-right mt-[8px] mb-0"
      >
        0/700
      </p>
    </b-form-group>
    <div class="select-none">
      <span class="text-[#333] text-[14px] after:content-['*'] after:text-red-500 mb-[24px]">Question</span>
      <input
        id="tab"
        ref="tab"
        type="checkbox"
        class="hidden peer"
      >
      <div
        class="peer-checked:[&>:first-child]:after:translate-x-full peer-checked:[&>:first-child>:first-child]:text-[#626262]
            peer-checked:[&>:first-child>:last-child]:text-[#F95031] peer-checked:[&>:last-child>*]:-translate-x-full"
      >
        <div
          class="flex h-[28px] !border-b border-[#E2E2E2] relative after:absolute after:h-[4px] after:w-[118px] after:rounded-t-full
              after:bg-[#F95031] after:bottom-0 after:left-0 after:transition-transform after:duration-300 after:will-change-transform
              [&>*]:transition-colors [&>*]:duration-300"
        >
          <button
            type="button"
            class="h-[20px] w-[118px] text-[14px] text-[#F95031] hover:!text-[#F95031] outline-none"
            @click="$refs.tab.checked && $refs.tab.click()"
          >
            Standar
          </button>
          <button
            type="button"
            class="h-[20px] w-[118px] text-[14px] text-[#626262] hover:text-[#F95031] outline-none"
            @click="!$refs.tab.checked && $refs.tab.click()"
          >
            Custom
          </button>
        </div>
        <div class="border border-[#E2E2E2] rounded-[10px] mt-[16px] flex overflow-hidden w-full">
          <div
            v-for="tabdata, tabkey in constants.FIELD_OPTIONS"
            :key="tabkey"
            class="min-w-full max-h-[380px] py-[20px] overflow-y-auto flex flex-col gap-[20px] transition-transform duration-300 will-change-transform"
          >
            <div
              v-for="options, key in tabdata"
              :key="`${tabkey}-${key}`"
            >
              <span class="px-[20px]">{{ key }}</span>
              <div
                class="px-[20px] pt-[20px] flex gap-[16px] flex-wrap"
              >
                <label
                  v-for="option, idx in options"
                  :key="`${tabkey}-${key}-${idx}`"
                  :for="`${tabkey.replaceAll(' ', '-')}-${key.replaceAll(' ', '-')}-${idx}`"
                  class="h-[90px] cursor-pointer m-0 grow basis-[120px] 2xl:basis-[200px] !border border-[#E2E2E2] flex flex-col
                      gap-[4px] items-center justify-center text-[#F95031] text-[14px] rounded-[8px] hover:border-[#F95031]
                      active:bg-[#F95031]/10 transition-colors duration-3 [&>*]:translate-y-1"
                  :class="{'has-[:checked]:opacity-60 has-[:checked]:pointer-events-none': tabkey === 'standar'}"
                >
                  <input
                    :id="`${tabkey.replaceAll(' ', '-')}-${key.replaceAll(' ', '-')}-${idx}`"
                    type="checkbox"
                    :checked="isCheckedStandarField(tabkey, option.label)"
                    class="hidden"
                    @change="$emit('update:fields', [...fields, { ...option, id: `new-${fields.length}` }])"
                  >
                  <img
                    :src="option.icon"
                    :alt="option.label"
                    width="40"
                    height="40"
                  >
                  <span class="truncate max-w-[120px]">{{ option.label }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FIELD_OPTIONS } from '../constants/komlabs-registration'

export default {
  props: {
    banner: {
      type: File,
      default: null,
    },
    fields: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    constants() {
      return { FIELD_OPTIONS }
    },
  },
  destroyed() {
    const source = this.$refs.banner?.src
    if (source) URL.revokeObjectURL(source)
  },
  methods: {
    isCheckedStandarField(tabkey, label) {
      return tabkey === 'standar' && this.fields.map(field => field.label).includes(label)
    },
    async getImageData(file) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        const src = URL.createObjectURL(file)

        img.onload = () => {
          resolve({
            src,
            width: img.naturalWidth,
            height: img.naturalHeight,
            ratio: img.naturalWidth / img.naturalHeight,
          })
        }

        img.onerror = () => {
          URL.revokeObjectURL(src)
          reject(new Error('Invalid image'))
        }

        img.src = src
      })
    },
    setBannerSource(src) {
      this.$refs.banner.src = src
      this.$refs.banner.classList.remove('hidden')

      const preview = document.querySelector('img[alt="preview"]')
      preview.src = src
      preview.classList.remove('hidden')
    },
    setTextCount(overview, closing) {
      this.$refs.overviewCount.textContent = `${overview.length}/500`
      this.$refs.closingCount.textContent = `${closing.length}/700`
    },
    async updateBanner(e) {
      const input = e.target
      const file = input.files[0]
      if (!file) return
      const fileSize = Math.round((file.size / 1024) * 100) / 100
      try {
        if (fileSize > 1000) {
          this.$toast_error({ message: `Ukuran file terlalu besar (${fileSize} KB). Maksimal 1000KB.` })
          return
        }

        const {
          src, width, height, ratio,
        } = await this.getImageData(file)
        if (ratio !== 4) {
          this.$toast_error({ message: `Rasio gambar salah (${width}:${height}). Seharusnya 4:1.` })
          return
        }

        this.$emit('update:banner', file)
        this.setBannerSource(src)
      } catch (error) {
        this.$toast_error({ message: 'Pengambilan gambar gagal.' })
      } finally {
        input.value = null
      }
    },
    resetForm() {
      this.$emit('update:fields', [])
      this.$emit('update:banner', null)

      if (this.$refs.banner?.src) {
        URL.revokeObjectURL(this.$refs.banner.src)
        this.$refs.banner.src = ''
        this.$refs.banner.classList.add('hidden')

        const preview = document.querySelector('img[alt="preview"]')
        preview.src = ''
        preview.classList.add('hidden')
      }

      this.$refs.overviewCount.textContent = '0/500'
      this.$refs.closingCount.textContent = '0/700'
      this.$refs.tab.checked = false
    },
  },
}
</script>
